import _ from 'lodash';
import { creatingHelpers } from '../../common/creating';
import { filterHelpers } from '../../common/filtering';
import { sortObject } from '../../common/sorting';
import { gEnums } from '../../enums/globalEnums';
import { _settingsFs } from '../actions/getSettings';

const isMajorView = (appArea) => {
  switch (appArea) {
    case gEnums.appAreaTypes.client:
    case gEnums.appAreaTypes.club:
    case gEnums.appAreaTypes.event:
    case gEnums.appAreaTypes.league:
    case gEnums.appAreaTypes.school:
      return true
    default:
      return false
  }
}

const createPropsFromList = (itemList) => {
  const ips = {}
  Object.keys(itemList).forEach(key => {
    const itemData = itemList[key]
    switch (key) {
      case 'key':
      case 'id':
      case 'uid':
        break;
      default:
        let formItemType = gEnums.formItemTypes.text
        if (_.isObject(itemData)) {
          if (_.isArray(itemData)) {
            formItemType = gEnums.formItemTypes.dropdown
          }
        }
        ips[key] = {
          key: key,
          data: { formItemType: formItemType },
          propSection: gEnums.sectionHeaderNames.details,
          ui: {
            caption: _.startCase(key),
            elemPropType: gEnums.elemPropTypes.normal
          }
        }
    }
  })
  delete ips.id
  return ips
}

const getAppFormProps = (vit, appForms) => {

  let vProps;

  switch (vit) {
    case gEnums.profileSelectTypes.appProfiles:
      vProps = appForms.appUser
      break;
    case gEnums.profileSelectTypes.profiles:
      vProps = appForms.profile
      break;
    case gEnums.profileSelectTypes.clientProfiles:
      vProps = appForms.clientProfile
      break;
    case 'notifications':
      vProps = appForms.notification
      break;
    default:
    // console.log('no fixed props vit', vit)
  }

  return vProps

}

const createPropsFromData = (viewListData) => {
  const props = {}
  Object.keys(viewListData).forEach(key => {
    const item = viewListData[key]
    createPropsFromItem(item, props)
  })
  return props
}

const createPropsFromItem = (item, propsObj, swipedItem, showOnly) => {

  if (swipedItem && swipedItem.key) {
    switch (swipedItem.key) {
      case 'profiles':
        if (!item.accessLevel) {
          item['accessLevel'] = 0
        }
        break;
      default:
      // nothing
    }
  }

  Object.keys(item).forEach(diKey => {

    if (!propsObj[diKey]) {

      let show = true

      switch (diKey) {
        case 'accessLevel':
          break;
        case 'id':
          // disabled = true
          break;
        default:
        // nothing
      }


      if (show) {
        propsObj[diKey] = {

          key: diKey,
          data: { formItemType: "text" },
          propSection: gEnums.sectionHeaderNames.details,
          ui: {
            caption: _.startCase(diKey),
            elemPropType: gEnums.elemPropTypes.normal
          }
        }
        switch (diKey) {
          case 'name':
          case 'firstName':
          case 'lastName':
            propsObj[diKey].elemPropType = gEnums.elemPropTypes.header
            break;
          default:
          // nothing
        }
      }
    }
  })
}

/** Retuns the settingKey needed for the view */
const getViewSettingsBaseName = (view, pathViews) => {

  let name = 'home'

  if (pathViews?.events) {
    name = pathViews.events
  } else if (pathViews?.clients) {
    name = pathViews.clients
  } else if (view === 'events') {
    name = view
  } else if (view === 'clients') {
    name = view
  } else if (view === 'home') {
    name = 'home'
  }

  return name

}

const getViewSettingsKeys = (view, pathViews) => {

  const sdks = {}

  sdks['home'] = 'home'
  sdks['clients'] = 'clients'

  if ((pathViews && pathViews.events)) {
    sdks['event'] = pathViews.events
    sdks['client'] = pathViews.clients
  } else if (pathViews && pathViews.clients) {
    sdks['client'] = pathViews.clients
  }

  return sdks
}

const getSettingsProps = (view, pathViews, useOld) => {

  let baseSettingsName = getViewSettingsBaseName(view, pathViews)

  let settingsCollectionName = null
  let settingsDocKey = null
  let settingsDocType;

  let isAll = false

  switch (baseSettingsName) {
    case 'home':
      settingsCollectionName = 'homeSettings'
      settingsDocKey = 'home'
      break;
    case 'clients':
      settingsCollectionName = 'clientSettings'
      settingsDocKey = pathViews.clients
      break;
    case 'events':
      settingsCollectionName = 'appSettings'
      settingsDocKey = pathViews.events
      break;
    default:
    // nothing
  }

  if (pathViews?.events) {
    settingsDocType = 'events'
    settingsDocKey = 'home'
  } else if (pathViews?.clients) {
    settingsDocType = 'clients'
    settingsDocKey = pathViews.clients
  } else {
    settingsDocType = 'home'
    settingsDocKey = pathViews.events
  }

  if (!useOld) {
    settingsCollectionName = _settingsFs.root
    baseSettingsName = 'main'
  }

  if (!settingsDocKey) {
    settingsDocKey = baseSettingsName //+ 'All'
    isAll = true
  }

  return {
    baseSettingsName: baseSettingsName,
    settingsCollectionName: settingsCollectionName,
    settingsDocKey: settingsDocKey,
    isAll: isAll,
    settingsDocType,
  }
}

// const getViewItemHeaders = (viewItem) => {
//   const _props = []
//   const _groupedItems = getPropSectionsGrouped({props_viewItem: viewItem.props, propSections:  viewItem.propSections, true})
//   if (_groupedItems) {
//     Object.keys(_groupedItems).forEach(key => {
//       const gi = _groupedItems[key]
//       if (gi && gi.props) {
//         const pp = _.sortBy(gi.props, 'position')
//         pp.forEach(i => {
//           _props.push(i.key)
//         })
//       }
//     })
//   }
//   return _props
// }

/**
 * props => groupBy propSection
 * get the props for each section
 * @param {*} props_viewItem 
 * @param {*} propSections 
 * @param {*} showAll 
 * @param {*} desktopMode 
 * @param {*} display_global 
 * @param {*} propGroups 
 * @param {*} viewItem 
 * @param {*} aps_appUserSettings 
 * @param {*} itemData 
 * @returns 
 */
const getPropSectionsGrouped = (
  {
    aps_appUserSettings,
    desktopMode,
    display_global,
    itemData,
    propGroups,
    props_viewItem,
    propSections,
    showAll,
    viewItem,
  }


) => {

  const {
    props: prs,
    propSections: ps,
    display,
    desktopDisplay,
    itemColor,
    drillDown
  } = viewItem ?? {}

  let semPropSections = {}

  const _showProp = desktopMode ? gEnums.showTypes.showDesktop : gEnums.showTypes.show
  const { pin } = propGroups ?? {}
  const { propArray: propsToSeparate } = pin ?? {}

  const { propsToSeparate: propsToSeparate_global } = display_global ?? {}

  let _propsToSeparate = [];

  if (propsToSeparate && propsToSeparate_global) {
    _propsToSeparate = [...propsToSeparate, ...propsToSeparate_global]
  } else if (propsToSeparate) {
    _propsToSeparate = propsToSeparate
  } else if (propsToSeparate_global) {
    _propsToSeparate = propsToSeparate_global
  }

  if (_propsToSeparate) {

    _.forEach(_propsToSeparate, (pts) => {
      if (props_viewItem && props_viewItem[pts]) {
        if (semPropSections && !semPropSections[pts]) {

          // if (itemData && itemData[pts]) {
          //   props_viewItem[pts].propSection = pts
          //   createPropSection(propSections, pts, gEnums.sectionDisplayTypes.separate)
          // }

          const { showOverview, appUserCollections, appUserOverviewPages } = aps_appUserSettings ?? {}

          if (showOverview && appUserOverviewPages && appUserCollections && appUserCollections.includes(viewItem.key)) {

            appUserOverviewPages.forEach(appUserOverviewPage => {

              const _section = _.camelCase(appUserOverviewPage.replace('appUser', ''))

              switch (appUserOverviewPage) {
                case gEnums.appUserProfilePageTypes.appUserAboutMe:
                case gEnums.appUserProfilePageTypes.appUserBio:
                  props_viewItem[_.camelCase(_section)] = newPropEditItem(_section, gEnums.formItemTypes.text, null, _section)
                  createPropSection(propSections, _section, gEnums.sectionDisplayTypes.separate)
                  break;

                case gEnums.appUserProfilePageTypes.appUserGallery:
                  props_viewItem[_.camelCase(_section)] = newPropEditItem(_section, gEnums.formItemTypes.text, null, _section)
                  createPropSection(propSections, _section, gEnums.sectionDisplayTypes.gallery)
                  break;

                default:
                  return false
              }
            })
          }
        }
      }
    })
  }

  if (propSections) {
    Object.keys(propSections).forEach(psKey => {
      if (!propSections[psKey].position) { propSections[psKey].position = 0 }
    })
    semPropSections = sortObject(propSections, 'position')
  }

  if (semPropSections && !showAll) { semPropSections = filterHelpers.filterObject(semPropSections, _showProp) }

  creatingHelpers.createKeys(props_viewItem)

  // groupBy propSection
  let propSectionGroups = _.groupBy(props_viewItem, 'propSection')

  Object.keys(semPropSections).forEach(sectionKey => {
    if (propSectionGroups[sectionKey]) {
      semPropSections[sectionKey].props = creatingHelpers.createObject(propSectionGroups[sectionKey], 'key')
    }
  })

  return semPropSections

}

const createPropSection = (propSections, sectionName, sectionDisplayType) => {
  propSections[sectionName] = {
    key: sectionName,
    position: Object.keys(propSections).length,
    show: true,
    sectionBody: {
      bodyDisplayType: gEnums.sectionBodyTypes.noCaptions
    },
    sectionHeader: {
      headerDisplayType: gEnums.sectionHeaderTypes.divider
    },
    sectionDisplay: {
      sectionDisplayType: sectionDisplayType,
      showHeader: true,
      sectionHeaderCaption: _.startCase(sectionName)
    }
  }
}

const getPropsFromSections = (sectionProps) => {

  const ps = _.sortBy(sectionProps, 'position')
  const allProps = []

  ps.forEach(aaa => {
    let poz = 0
    if (aaa.props) {
      const a = _.filter(aaa.props, { _allowProp: 'allow' })
      const c = _.sortBy(a, 'position')
      c.forEach(ci => {
        ci.poz = poz
        allProps.push(ci)
        poz++
      })
    }
  })

  const allPropsO = creatingHelpers.createObject(allProps, 'key')
  const propsSorted = _.sortBy(allPropsO, 'poz')

  return propsSorted
}

const newPropEditItem = (key, formItemType, listType, propSection, viewOnly, opts) => {
  const _data = { formItemType: formItemType, required: false, listType }
  const dataOpts = opts ? { ..._data, ...opts } : _data
  const npei = {
    data: dataOpts,
    key: key,
    position: 0,
    show: true,
    propSection: propSection ? propSection : 'other',
    ui: {
      caption: _.startCase(key)
    },
    _allowProp: true,
    viewOnly,
  }
  return npei
}

const newPropObject = (prop, opts, pdo) => {

  const dataOpts = {
    ...pdo,
    ...opts
  }

  const xxx = {
    prop: prop,
    data: { ...dataOpts },
    ui: {
      caption: _.startCase(prop),
    },
  }

  return xxx
}

const getVal = (obj, settings) => {
  let r = null
  try {
    settings.forEach(s => {
      if (!r) {
        r = obj[s]
      } else {
        r = r[s]
      }
    })
  } catch (error) {
    console.error(error)
  }
  return r ?? {}
}

const getSvs = (isGlobal, pageContext, settings, groups) => {

  const { page_state } = pageContext ?? {}
  const { pageSettings } = page_state ?? {}
  const { aps_global, aps_page } = pageSettings ?? {}

  let result = null
  if (isGlobal) {
    if (groups) {
      result = {}
      groups.forEach(g => {
        if (g) {
          const gs = g.split('/')
          const p = gs[gs.length - 1]
          const r = getVal(aps_global, gs)
          result[p] = r ?? {}
        }
      })
    } else {
      result = getVal(aps_global, settings)
    }
  } else {
    if (groups) {
      result = {}
      groups.forEach(g => {
        if (g) {
          const gs = g.split('/')
          const p = gs[gs.length - 1]
          const r = getVal(aps_page, gs)
          result[p] = r ?? {}
        }
      })
    } else {
      result = getVal(aps_page, settings)
    }
  }
  return result
}

const addViPropsFromAdditional = (aps_viewItems, aps_views, vit, itemProps) => {

  const _aps_viewItems = { ...aps_viewItems }
  const _aps_views = { ...aps_views }

  if (_aps_viewItems[vit]) { addViPropsToViewItems(_aps_viewItems, vit, itemProps) }

  addViPropsToViews(_aps_views, vit, false, itemProps)
  addViPropsToViews(_aps_views, vit, true, itemProps)

  return {
    viewKey: vit,
    viewItem: _aps_viewItems[vit] ? _aps_viewItems[vit] : null,
    view: _aps_views[vit] ? _aps_views[vit] : null,
    viewList: _aps_views[vit + '_list'] ? _aps_views[vit + '_list'] : null
  }
}

const addViPropsToViewItems = (aps_viewItems, vit, itemProps) => {
  if (aps_viewItems[vit]) {
    const aps_viewItem = aps_viewItems[vit]
    const { props: props_vi } = aps_viewItem
    if (props_vi && itemProps) {
      Object.keys(itemProps).forEach(propKey => {
        if (!props_vi[propKey]) {
          props_vi[propKey] = itemProps[propKey]
        }
      })
      delete props_vi._itemKey
      delete props_vi._gsId
    }
  }
}

const addViPropsToViews = (aps_views, vit, forList, itemProps) => {
  if (aps_views[vit]) {
    const view = forList ? aps_views[vit + '_list'] : aps_views[vit]
    const { viewItems: viewItems_view } = view
    if (viewItems_view && viewItems_view[vit]) {
      const viewItem_view = viewItems_view[vit]
      const { props: props_vi } = viewItem_view
      if (props_vi && itemProps) {
        Object.keys(itemProps).forEach(propKey => {
          if (!props_vi[propKey]) {
            props_vi[propKey] = itemProps[propKey]
          }
        })
        delete props_vi._itemKey
        delete props_vi._gsId
      }
    }
  }
}

export const settingsHelpers = {
  addViPropsFromAdditional,
  createPropSection,
  createPropsFromData,
  createPropsFromItem,
  createPropsFromList,
  getAppFormProps,
  getPropSectionsGrouped,
  getPropsFromSections,
  getSettingsProps,
  getSvs,
  // getViewItemHeaders,
  getViewSettingsBaseName,
  getViewSettingsKeys,
  isMajorView,
  newPropEditItem,
  newPropObject,
}